export default "__VITE_ASSET__4084978e__"